import { Button, Checkbox, FormControlLabel } from "@mui/material"
import { Visibility, VisibilityOff } from "@mui/icons-material"
import { useTranslation } from "react-i18next";
import { FC } from "react";
import { 
  INoCessionSIPSFetchData, 
  NoSIPSCessionStates 
} from "../../../types/noSIPSCession";
import { Tooltip } from "@gisce/oficina-virtual-components";
import useAuth from "@/components/Authentication/hooks/useAuth";
import { useSettingsContext } from "@/components/Settings/hooks/useSettingsContext";

interface IContractNoCessionProps {
  dialogOpen: () => void;
  isAtrAvailable: boolean;
  isContactActive: boolean;
  noSIPSCession: INoCessionSIPSFetchData;
}

interface ISIPSCessionStatusProps {
  checked: boolean;
  label: string;
}

type SIPSCessionCases = {
  [key in NoSIPSCessionStates]: ISIPSCessionStatusProps;
}

export const NoSIPSCessionAction: FC<IContractNoCessionProps> = ({
  dialogOpen,
  isAtrAvailable,
  isContactActive,
  noSIPSCession
}) => {
  const { t } = useTranslation();
  const Settings = useSettingsContext();

  const { tokenVals } = useAuth();
  const SIPSCessionCases: SIPSCessionCases = {
    "requested": { checked: false, label: t('common:text.sips_requested') },
    "active": { checked: true, label: t('common:text.sips_active') },
    "unactive": { checked: false, label: t('common:text.sips_disabled') }
  }

  return (
    <div>      
      <div>

        <FormControlLabel
          control={
            <Checkbox
              disabled={true}
              checked={SIPSCessionCases[noSIPSCession.state].checked}
              checkedIcon={<VisibilityOff />}
              icon={<Visibility />}
            />
          }
          label={t('common:text.sips_title')}
        />

        {!Settings?.contract?.horizontalButtons &&
          <Tooltip
            title={tokenVals?.readonly &&
              t("common:text.token_readonly_tooltip")
            }
            placement="right"
            arrow
            disableFocusListener={!tokenVals?.readonly}
            disableHoverListener={!tokenVals?.readonly}
            disableTouchListener={!tokenVals?.readonly}
            slotProps={{
              popper: {
                modifiers: [{
                  name: 'offset',
                  options: {offset: [0, -5]}
                }]
              }
            }}
          >
            <span style={{ 'width': '100%' }}>
              <Button
                color={'primary'}
                variant={'text'}
                disabled={
                  (noSIPSCession.state == "requested"
                    && !noSIPSCession.waiting_for_signature)
                  || !isAtrAvailable
                  || !isContactActive
                  || !!tokenVals?.readonly
                }
                title={t('common:text.sips_edit_data')}
                onClick={() => dialogOpen()}
              >
                {SIPSCessionCases[noSIPSCession.state]?.label}
              </Button>
            </span>
          </Tooltip>
        }

      </div>

      { noSIPSCession.state === 'requested' &&
        <div style={{ fontSize: '12px' }}>
          <em>{t('common:text.sips_process_already')}</em>
        </div>
      }

    </div>
  );
}
